import React from "react";
import Title from "./Title";

function Flagmans({ containerClassNames = "text-white" }) {
    return (
        <div
            id="flagmans"
            className={`${containerClassNames} flex justify-center items-center px-6 xl:px-24 pt-14 xl:pt-36 flex-col`}
        >
            <div className="mb-8 xl:mb-24 text-center">
                <Title title={"Флагмани колекції"} />
                <div className="text-xs">натисніть щоб замовити</div>
            </div>
        </div>
    );
}

export default Flagmans;
